// extracted by mini-css-extract-plugin
export var standaloneTable = "_em-0";
export var standaloneTableWithBodyFill = "_em-1";
export var withExtraHeader = "_em-2";